import './PreventiveDetailsContent.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useMemo } from "react";

import { useParams } from "react-router-dom";

import { fetchViolations } from "../../../../../slices/violationsSlice";

import { openModal } from "../../../../../slices/modalSlice";
import { openDrawer } from "../../../../../slices/drawerSlice";

import Bookmark from "@mui/icons-material/Bookmark";
import QuestionMark from "@mui/icons-material/QuestionMark";

import { Message } from "../../../../../common-components/Message/Message";
import { TextButton } from "../../../../../common-components/Buttons/Buttons";
import { Table } from "../../../../../common-components/Table/Table";
import { List } from "../../../../../common-components/List/List";
import { Status } from "../../../../../common-components/Status/Status";

import PreventiveIssueDetails from "../../../PreventiveIssueDetails/PreventiveIssueDetails";
import PreventiveLinksModal from "../../../PreventiveLinksModal/PreventiveLinksModal";
import PreventiveDetailsTools from "../PreventiveDetailsTools/PreventiveDetailsTools";
import PreventiveIssueDetailsFooter
    from "../../../PreventiveIssueDetails/components/PreventiveIssueDetailsFooter/PreventiveIssueDetailsFooter";

const PreventiveDetailsContent = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const columnsFromStore = useSelector((state) => state.violations.columns);
    const dataFromStore = useSelector((state) => state.violations.data);

    useEffect(() => {
        dispatch(fetchViolations({ token, id }));
    }, [dispatch, token, id]);

    const columns = useMemo(() => {
        if (!columnsFromStore) return [];
        return columnsFromStore.map(col => ({
            key: col.key,
            header: col.alias || col.name || col.key
        }));
    }, [columnsFromStore]);

    const data = useMemo(() => {
        if (!Array.isArray(dataFromStore)) return [];
        return dataFromStore.map(item => {
            const attributes = item?.attributes || {};
            return {
                id: item.id,
                ...attributes
            };
        });
    }, [dataFromStore]);

    const renderCell = (key, value) => {
        if (key === "elimination_completion") {
            switch (value) {
                case true:
                    return <Status title={"Устранено"} color={"success"}/>
                case false:
                    return <Status title={"Не устранено"} color={"danger"}/>
                default:
                    return <Status title={"Отсутствует"}/>
            }
        }

        if (key === "elimination_completion_date") {
            return <span>{value || "Отсутствует"}</span>;
        }
        return value;
    }

    const handleOpenModal = () => {
        dispatch(openModal({content: <PreventiveLinksModal/>, closeable: true}));
    }

    const handleOpen = ({id}) => {
        dispatch(openDrawer({content: <PreventiveIssueDetails id={id}/>, footer: <PreventiveIssueDetailsFooter id={id}/>, tools: <TextButton Icon={Bookmark} title={"Правила пром.безопасности"} active={true} onClick={handleOpenModal} color={"#01579b"}/>}));
    }

    const renderDesktopTable = () => {
        if (Array.isArray(dataFromStore) && dataFromStore.length === 0) {
            return <Message Icon={QuestionMark} description={"Отсутствуют нарушения"}/>
        } else {
            return <Table data={data} additionalColumns={columns} renderCell={renderCell} onRowClick={handleOpen}/>
        }
    }

    const renderMobileList = () => {
        if (Array.isArray(dataFromStore) && dataFromStore.length === 0) {
            return <Message Icon={QuestionMark} description={"Отсутствуют нарушения"}/>
        } else {
            return <List data={data} additionalColumns={columns} renderCell={renderCell} onClick={handleOpen}/>
        }
    }

    return (
        <div className={"preventive-details-content"}>
            <div className={"preventive-details-content_container"}>
                <div className={"preventive-details-content_tools"}>
                    <PreventiveDetailsTools id={id}/>
                </div>
                <div className={"preventive-details-content_table"}>
                    {renderDesktopTable()}
                </div>
                <div className={"preventive-details-content_list"}>
                    {renderMobileList()}
                </div>
                <div className={"preventive-details-content_pagination"}>
                    {/*<Pagination meta={data}/>*/}
                </div>
            </div>
        </div>
    )
}

export default PreventiveDetailsContent;